import React from 'react'
import {useNotification} from '../../common/notifications/useNotification'
import {IconButton} from '../../webui/IconButton'
import {CopyIcon} from '../../webui/icons/CopyIcon'
import {AllRentalData} from './types'
import {getDisplayRental} from './utils/getDisplayRental'
import {Tooltip} from '@mui/material'

interface Props {
  rental: AllRentalData
}

export const CopyRentalButton: React.FC<Props> = ({rental}) => {
  const {showNotification} = useNotification()

  const onClick = async () => {
    const message = getDisplayRental(rental)
    await navigator.clipboard.writeText(message)
    showNotification({
      message: 'Rental copied to clipboard',
      severity: 'success',
    })
  }

  return (
    <Tooltip title="Copy this rental to the clipboard" placement="top">
      <IconButton sx={{padding: 0}} onClick={onClick}>
        <CopyIcon />
      </IconButton>
    </Tooltip>
  )
}
